import { Component, StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/inter';
import '@fontsource/jetbrains-mono/400.css';
import './styles/global.css';
import './styles/pages.css';
import './styles/management.css';
import App from './App';
import { ConsoleProvider } from './state/ConsoleProvider';
import { consoleBasePath } from './lib/config';

class ErrorBoundary extends Component<{children:ReactNode},{failed:boolean}> {
  state={failed:false};
  static getDerivedStateFromError(){return{failed:true};}
  render(){return this.state.failed?<main className="initial-loading" role="alert"><h1>We couldn’t load this view.</h1><p>Reload the console to try again.</p><button className="button button-primary" onClick={()=>window.location.reload()}>Reload console</button></main>:this.props.children;}
}

createRoot(document.getElementById('root')!).render(<StrictMode><ErrorBoundary><BrowserRouter basename={consoleBasePath}><ConsoleProvider><App/></ConsoleProvider></BrowserRouter></ErrorBoundary></StrictMode>);
